export default __webpack_public_path__ + "static/media/i_wdt_c_4.5099a6eb.mp3";